<header mat-dialog-title>
    <div class="dialog-header">
        <h3 class="mat-h2">Registrar clase perdida</h3>
        <button mat-icon-button mat-dialog-close>
            <mat-icon color="primary">close</mat-icon>
        </button>
    </div>
    <mat-divider></mat-divider>
</header>

<mat-dialog-content>

    <form [formGroup]="clasePerdidaForm">
        <div class="table-tools">
            <mat-form-field appearance="outline" class="full-width">
                <mat-label for="fecha">Fecha de la clase</mat-label>
                <input matInput [matDatepicker]="picker" formControlName="fecha" readonly>
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
                <mat-error>Dato obligatorio</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="full-width">
                <mat-label for="materiaCursoPeriodoID">Materia</mat-label>
                <mat-select i18n-placeholder="@@materias" placeholder="Seleccione la materia"
                    formControlName="materiaCursoPeriodoID">
                    <mat-option *ngFor="let mcp of data.materias$ | async" [value]="mcp.id">
                        {{mcp.nombre}}
                    </mat-option>
                </mat-select>
                <mat-error>Dato obligatorio</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="full-width">
                <mat-label for="horas">Horas perdidas</mat-label>
                <input matInput type="number" formControlName="horas" placeholder="Horas de clase perdidas" />
                <mat-error>Dato obligatorio</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="full-width">
                <mat-label for="motivo">Motivo</mat-label>
                <input matInput formControlName="motivo" placeholder="Motivo por el cual no hubo clase" />
                <mat-error>Dato obligatorio</mat-error>
            </mat-form-field>
        </div>
    </form>

</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Cancelar</button>
    <button mat-button color="primary" [mat-dialog-close]="true" (click)="create(clasePerdidaForm)"
        [disabled]="clasePerdidaForm.invalid">Guardar y cerrar</button>
</mat-dialog-actions>